import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EaeHeaderNavigationComponent } from './eae-header-navigation/eae-header-navigation.component';
import { AgendaEduModule } from 'agenda-edu';
import { EaeBottomSheetComponent } from './eae-bottom-sheet/eae-bottom-sheet.component';


@NgModule({
  declarations: [EaeHeaderNavigationComponent, EaeBottomSheetComponent],
  imports: [CommonModule, AgendaEduModule],
  exports: [EaeHeaderNavigationComponent, EaeBottomSheetComponent],
})
export class SharedModule {}
